import { Injectable } from '@angular/core';
import { Pipe } from '@angular/core';
import { PipeTransform } from '@angular/core';
import { AdvertisersSelectors } from 'app/modules/main/store/advertisers/advertisers.selectors';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'advertiserName' })
export class AdvertiserNamePipe implements PipeTransform {

  constructor(
    private readonly advertisersSelectors: AdvertisersSelectors,
  ) {
  }

  transform(
    advertiserId: number
  ): Observable<string> {

    return this.advertisersSelectors
      .getAdvertiser(advertiserId)
      .pipe(map(advertiser => advertiser?.name));
  }

}
